import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditBig: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEditBig"><Path d="M11.5 3.5H3.5V20.5H20.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 16.5V13.5L18.25 2.75L21.25 5.75L10.5 16.5H7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconEditBig;
